/* eslint-disable react-hooks/exhaustive-deps */
// Components
import { Slider } from '../../../Slider';

// Utils
import { msToTime } from '../../../../utils';

// Context
import { usePlayback } from '../../../../contexts/PlaybackContext';
import { memo, useEffect, useMemo, useState } from 'react';
import { deriveQueuePointer } from '../../../../lib/playback/queueDisplay';

const SongProgressBar = memo(() => {
  const { playerState, queueSession, queueItems, seekToPosition } = usePlayback();

  const pointer = useMemo(() => deriveQueuePointer(queueSession, queueItems), [queueItems, queueSession]);
  const currentQueueItem = pointer.item;

  const duration =
    playerState?.duration ??
    (typeof currentQueueItem?.durationMs === 'number' ? currentQueueItem.durationMs : undefined);

  // TEMP: rely solely on Spotify SDK position to inspect resume behavior.
  const position = typeof playerState?.position === 'number' ? playerState.position : undefined;

  const loaded = typeof duration === 'number' && duration > 0;

  const [value, setValue] = useState<number>(0);
  const [selecting, setSelecting] = useState<boolean>(false);

  useEffect(() => {
    if (typeof position === 'number' && typeof duration === 'number' && duration > 0 && !selecting) {
      setValue(position >= duration ? 0 : position / duration);
    }
  }, [position, duration, selecting]);

  return (
    <div className='flex items-center justify-between w-full' style={{ maxWidth: 700 }}>
      <div className='text-white mr-2 text-xs'>
        {typeof position === 'number' ? msToTime(position) : '0:00'}
      </div>
      <div style={{ width: '100%' }}>
        <Slider
          isEnabled
          value={value}
          onChangeStart={() => {
            setSelecting(true);
          }}
          onChange={(value) => {
            setValue(value);
          }}
          onChangeEnd={(value) => {
            setSelecting(false);
            if (!loaded) return;
            setValue(value);
            const baseDuration = typeof duration === 'number' ? duration : 0;
            const newPosition = Math.round(baseDuration * value);
            seekToPosition(newPosition).catch(() => {});
          }}
        />
      </div>
      <div className='text-white ml-2 text-xs'>
        {typeof duration === 'number' && duration > 0 ? msToTime(duration) : '0:00'}
      </div>
    </div>
  );
});

export default SongProgressBar;
